import { useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { getCommentBoxId } from '../../../CommentThread/helpers';
import { focusEditor } from '../../../CommentEditor/redux/actionCreators';
import { focusEditor as focusEditorNew } from '../../../CommentEditor.editor_v3/redux/actionCreators';
import { scrollIntoViewWithHeader } from '../../../utils/scrollIntoViewWithHeader';
/** Returns a dispatched action that will focus on the comment box with the given ids */ export default function useFocusOnCommentBox(commentableTypeId, commentableItemId, position, scrollIntoView = true, extraHeaderHeight = 0) {
    const dispatch = useDispatch();
    const isEditorCommentFlagEnabled = useFlag('editor_comment');
    const commentBoxId = getCommentBoxId(commentableTypeId, commentableItemId, position);
    const isMobile = useContext(MobileContext);
    return useCallback(()=>{
        if (isEditorCommentFlagEnabled) {
            dispatch(focusEditorNew(commentBoxId));
        } else {
            dispatch(focusEditor(commentBoxId));
        }
        if (scrollIntoView && typeof document !== 'undefined') {
            const boxElement = document.getElementById(commentBoxId);
            boxElement && scrollIntoViewWithHeader(boxElement, isMobile, extraHeaderHeight, undefined, true, true);
        }
    }, [
        dispatch,
        commentBoxId,
        scrollIntoView,
        isMobile,
        extraHeaderHeight,
        isEditorCommentFlagEnabled
    ]);
}

//# sourceMappingURL=useFocusOnCommentBox.js.map